import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconMenu = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-menu" data-icon="icon-menu" aria-hidden="true" {...props} ref={ref}><line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="6" x2="20" y2="6"/><line x1="4" y1="18" x2="20" y2="18"/></svg>);
});

IconMenu.displayName = 'IconMenu';
